import React from 'react';
import POS from '../../components/sales/POS';

/**
 * Page component for the Point of Sale (POS) screen
 * @returns {JSX.Element} POS page
 */
const POSPage = () => {
  return <POS />;
};

export default POSPage; 